import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/Taxset';

const TaxsetList = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchTaxsetData();
  }, []);

  const fetchTaxsetData = async () => {
    try {
      const response = await axiosInstance.post(
        '/taxset/list',
        {
          orderBy: 'taxset_id desc',
          page: 0,
          pageSize: 10,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      console.log('response', response);
      setTableData(formattedData);
    } catch (error) {
      console.error('Error fetching taxset list:', error);
    }
  };

  const filteredData = tableData.filter((item) =>
    item.taxset_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Taxset</h5>
        </div>
        <div>
          <button
            className='addcustomerbutton'
            onClick={() => navigate(ROUTES_NAVIGATION.TAXSETADD)}
          >
            Add Taxset
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Taxset List</h5>
            <input
              type='text'
              className='searchinput'
              placeholder='Search Source'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* <div className='downloadiconwrapper'>
            <h6 className='downloadTitle'>Download</h6>
            <img src={downloadIcon} alt='download' />
          </div> */}
        </div>

        <CustomTable
          data={filteredData}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          itemsPerPage={5}
          totalRecords={totalRecords} 
        />
      </div>
    </div>
  );
};

export default TaxsetList;
